import { useState, useEffect, useRef } from 'react';

interface UseAutoReturnOptions {
  seconds: number;
  onComplete: () => void;
  enabled: boolean;
}

/**
 * 자동 복귀 카운트다운
 * - seconds부터 0까지 매초 감소
 * - 0이 되면 onComplete 콜백 호출
 */
export function useAutoReturn({ seconds, onComplete, enabled }: UseAutoReturnOptions) {
  const [remainingSeconds, setRemainingSeconds] = useState(seconds);
  const onCompleteRef = useRef(onComplete);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    if (!enabled) {
      setRemainingSeconds(seconds);
      return;
    }

    setRemainingSeconds(seconds);

    const interval = setInterval(() => {
      setRemainingSeconds((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          clearInterval(interval);
          // setTimeout으로 감싸서 setState 중 콜백 호출 방지
          setTimeout(() => onCompleteRef.current(), 0);
          return 0;
        }
        return next;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, enabled]);

  return { remainingSeconds };
}
